<template>
  <base-nav
    v-model="showMenu"
    type="light"
    :transparent="true"
    :show-navbar-toggle="false"
    :containerClasses="'container-fluid'"
    menu-classes="justify-content-end"
    class="navbar-horizontal navbar-main navbar-logged-in"
    expand="lg"
  >
    <div slot="brand" class="navbar-wrapper">
      <!-- Sidenav toggler -->
      <div
        class="pr-3 sidenav-toggler sidenav-toggler-light menu-sidenav-toggler"
        :class="navbarClass"
        @click="toggleSidebar"
      >
        <div class="sidenav-toggler-inner">
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
          <i class="sidenav-toggler-line"></i>
        </div>
      </div>
    </div>

    <div slot="toggle-button"></div>
  </base-nav>
</template>

<script>
import { BaseNav } from "@/components";

export default {
  name: "LoggedInNavBar",
  components: { BaseNav },
  data: () => ({
    showMenu: false
  }),
  methods: {
    toggleSidebar() {
      console.log("Toggling sidebar!");
      console.log(this.$sidebar.showSidebar);
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  },
  computed: {
    navbarClass() {
      const classes = [];
      if (this.$sidebar.showSidebar) classes.push("active");
      if (this.$route.meta.darkHeader) {
        classes.push("sidenav-toggler-dark");
      } else {
        classes.push("sidenav-toggler-light");
      }

      return classes;
    }
  }
};
</script>

<style></style>
